import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor, Essentials, Paragraph, Bold, Italic, Underline, Strikethrough,
  FontFamily, FontSize, FontColor, FontBackgroundColor,
  Alignment,
  List,
  Indent,
  Link,
  Image,
  Table,
  BlockQuote,
  HorizontalLine,
  HtmlEmbed,
  UndoCommand, RedoCommand
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';

const CommonCKEditor = ({ data, onChange, initialValue, customStyle }) => {
  return (
    <div style={{ border: '1px solid #ccc', borderRadius: '4px', marginBottom: '10px', ...(customStyle || {}) }}>
      <CKEditor
        editor={ClassicEditor}
        config={{
          licenseKey: 'GPL',
          plugins: [
            Essentials, Paragraph, Bold, Italic, Underline, Strikethrough,
            FontFamily, FontSize, FontColor, FontBackgroundColor,
            Alignment,
            List,
            Indent,
            Link,
            Image,
            Table,
            BlockQuote,
            HorizontalLine,
            HtmlEmbed,
            UndoCommand, RedoCommand
          ],
          toolbar: [
            'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|',
            'alignment', '|',
            'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'link', 'insertTable', 'blockQuote', 'horizontalLine', 'htmlEmbed'
          ],
          fontFamily: {
            options: [
              'default',
              'Arial, Helvetica, sans-serif',
              'Courier New, Courier, monospace',
              'Georgia, serif',
              'Lucida Sans Unicode, Lucida Grande, sans-serif',
              'Tahoma, Geneva, sans-serif',
              'Times New Roman, Times, serif',
              'Trebuchet MS, Helvetica, sans-serif',
              'Verdana, Geneva, sans-serif'
            ]
          },
          fontSize: {
            options: [
              'default',
              'tiny',
              'small',
              'medium',
              'large',
              'huge'
            ]
          },
          link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://'
          },
          table: {
            contentToolbar: [
              'tableColumn', 'tableRow', 'mergeTableCells'
            ]
          }
        }}
        data={data}
        initialValue={initialValue}
        onChange={onChange}
      />
    </div>
  );
};

export default CommonCKEditor;